module.exports = __webpack_public_path__ + "static/media/fynd-logo-byline-white.771d5c0a.svg";